export const AppLayout = {
  Default: "default",
  NoSidebar: "no-sidebar",
  Sidebar: "sidebar",
};
